<template>
  <div class="bg-home">
    <!-- Image TOP -->
    <section light>
      <v-parallax 
        :src="imageTop" 
        height="600">
        <v-layout
          column
          align-center
          justify-center
        >
          <!--
          <img 
            src="/img/vuetify.png"
            alt="Vuetify.js" 
            height="200">
          -->
          <h1 class="blue-grey darken-2 pa-2 mb-2 display-1 text-xs-center">{{ $t('site.name') }}</h1>
          <div class="blue-grey darken-2 pa-2 subheading mb-3 text-xs-center">{{ $t('page.home.title1') }}</div>
          <v-btn
            v-bind="style.section"
            class="mt-5"
            dark
            large 
            @click="navigateTo({name:'Sports'})">
            {{ $t('page.home.access') }} 
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <!-- Characteristics -->
    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center >
        <v-flex xs12>
          <v-container >
            <v-layout 
              row 
              wrap 
              class="content-top"
              align-center>
              <v-flex 
                v-for="characteristic in characteristics"
                :key="characteristic"
                class="text-xs-center"
                xs12 
                md3>
                <v-card 
                  v-vpshow
                  class="elevation-0 transparent" >
                  <!--
                  <v-card-text class="text-xs-center">
                    <v-icon 
                      x-large 
                      class="blue--text text--lighten-2">color_lens</v-icon>
                  </v-card-text>
                  -->
                  <v-card-title
                    primary-title
                    class="layout justify-center">
                    <div class="headline text-xs-center">{{ $t(`page.home.${characteristic}.title`) }}</div>
                  </v-card-title>
                  <v-card-text>
                    {{ $t(`page.home.${characteristic}.text`) }}
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <!-- Boards Image -->
    <section>
      <v-parallax 
        :src="boardsImage" 
        height="280">
        <v-layout 
          column 
          align-center 
          justify-center>
          <div class="headline white--text mb-3 text-xs-center">{{ $t('page.home.board.title') }}</div>
          <em>{{ $t('page.home.board.text') }}</em>
          <v-btn
            v-bind="style.section"
            class="mt-5"
            dark
            large
            @click="navigateTo({name:'Sports'})">
            {{ $t('page.home.access') }} 
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <!-- Boards -->
    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center >
        <v-flex xs12>
          <v-container >
            <v-layout 
              row 
              wrap 
              align-center>
              <v-flex 
                v-for="(board,i) in boards"
                :key="board.name"
                xs12>
                <v-card 
                  v-vpshow
                  class="elevation-0 transparent">
                  <v-container fluid >
                    <v-layout 
                      :reverse="i%2===0"
                      :class="{'text-sm-right':i%2===0,'text-sm-left':i%2!==0}"
                      class="text-xs-center"
                      wrap 
                      row>
                      <v-flex 
                        :class="{'text-sm-right':i%2!==0,'text-sm-left':i%2===0}"
                        class="text-xs-center"
                        xs12
                        sm6>
                        <img  
                          :src="board.image"
                          class="board-image" >
                      </v-flex>
                      <v-flex 
                        xs12
                        sm6>
                        <div>
                          <div class="headline">{{ $t(`page.home.board.type.${board.name}.title`) }}</div>
                          <div>{{ $t(`page.home.board.type.${board.name}.text`) }}</div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <!-- Stats Image -->
    <section>
      <v-parallax 
        :src="statsImage" 
        height="280">
        <v-layout 
          column 
          align-center 
          justify-center>
          <div class="headline white--text mb-3 text-xs-center">{{ $t('page.home.stats.title') }}</div>
          <em>{{ $t('page.home.stats.text') }}</em>
          <v-btn
            v-bind="style.section"
            class="mt-5"
            dark
            large
            @click="navigateTo({name:'Sports'})">
            {{ $t('page.home.access') }} 
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <!-- Stats -->
    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center >
        <v-flex xs12>
          <v-container >
            <v-layout 
              row 
              wrap 
              align-center>
              <v-flex 
                v-for="(stat,i) in stats"
                :key="stat.name"
                xs12 
                md12>
                <v-card 
                  v-vpshow
                  class="elevation-0 transparent">
                  <v-container fluid >
                    <v-layout 
                      :reverse="i%2===0"
                      :class="{'text-sm-right':i%2===0,'text-sm-left':i%2!==0}"
                      class="text-xs-center"
                      wrap 
                      row>
                      <v-flex 
                        :class="{'text-sm-right':i%2!==0,'text-sm-left':i%2===0}"
                        class="text-xs-center"
                        xs12
                        sm6>
                        <img  
                          :src="stat.image"
                          class="stats-image" >
                      </v-flex>
                      <v-flex 
                        xs12
                        sm6>
                        <div>
                          <div class="headline">{{ $t(`page.home.stats.type.${stat.name}.title`) }}</div>
                          <div>{{ $t(`page.home.stats.type.${stat.name}.text`) }}</div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <!-- Roles Image -->
    <section>
      <v-parallax 
        :src="rolesImage" 
        height="280">
        <v-layout 
          column 
          align-center 
          justify-center>
          <div class="headline white--text mb-3 text-xs-center">{{ $t('page.home.roles.title') }} </div>
          <em>{{ $t('page.home.roles.text') }} </em>
          <v-btn
            v-bind="style.section"
            class="mt-5"
            dark
            large
            @click="navigateTo({name:'Sports'})">
            {{ $t('page.home.access') }} 
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>

    <!-- Roles -->
    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center >
        <v-flex xs12>
          <v-container >
            <v-layout 
              row 
              wrap 
              class="content-top"
              align-center>
              <v-flex 
                v-for="role in roles"
                :key="role"
                class="text-xs-center"
                xs12 
                md3>
                <v-card 
                  v-vpshow
                  class="elevation-0 transparent">
                  <v-card-title
                    primary-title
                    class="layout justify-center">
                    <div class="headline text-xs-center">{{ $t(`page.home.roles.type.${role}.title`) }}</div>
                  </v-card-title>
                  <v-card-text>
                    {{ $t(`page.home.roles.type.${role}.text`) }}
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <!-- Info Image -->
    <section>
      <v-parallax 
        :src="infoImage" 
        height="180">
        <v-layout 
          column 
          align-center 
          justify-center>
          <div class="headline white--text mb-3 text-xs-center">{{ $t('page.home.info.title') }} </div>
          <!--
          <em>{{ $t('page.home.subtitle3') }} </em>
          -->
          <v-btn
            v-bind="style.section"
            dark
            large
            @click="navigateTo({name:'Sports'})">
            {{ $t('page.home.access') }} 
          </v-btn>
        </v-layout>
      </v-parallax>
    </section>


    <!-- Info & ContactUs -->
    <section>
      <v-container >
        <v-layout 
          row 
          wrap 
          justify-center 
          class="my-5">
          <v-flex
            xs12 
            sm5>
            <v-card 
              v-vpshow
              class="elevation-0 transparent">
              <v-card-title 
                primary-title 
                class="layout justify-center">
                <div class="headline">{{ $t('page.home.info.type.history.title') }}</div>
              </v-card-title>
              <v-card-text>
                {{ $t('page.home.info.type.history.text') }}
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex 
            xs12 
            sm5 
            offset-sm1>
            <v-card 
              v-vpshow
              class="elevation-0 transparent">
              <v-card-title 
                primary-title 
                class="layout justify-center">
                <div class="headline">{{ $t('page.home.contact.title') }}</div>
              </v-card-title>
              <v-card-text>
                {{ $t('page.home.contact.text') }}
              </v-card-text>
              <v-list class="transparent">
                <!--
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>777-867-5309</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">place</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Chicago, US</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                -->
                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">fas fa-envelope</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span 
                        class="cursor"
                        @click="mailTo">{{ $t('site.email') }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">fab fa-facebook</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span 
                        class="cursor"
                        @click="open($t('site.facebook.url'))">Facebook</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">fab fa-twitter</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span 
                        class="cursor"
                        @click="open($t('site.twitter.url'))">Twitter</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon class="blue--text text--lighten-2">fab fa-discord</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span 
                        class="cursor"
                        @click="open($t('site.discord.url'))">Discord</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// const debug = require('debug')('OD::Home')

export default {
  name: 'Home',
  components: {},
  props: {},
  data() {
    return {
      imageTop:
        'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Fizuddin-helmi-adnan-597822-unsplash.jpg?alt=media&token=a5949473-140c-459f-86ff-65de2b44f17e',
      characteristics: ['live', 'sports', 'stats', 'roles'],
      boardsImage:
        'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Fricardo-resende-642920-unsplash.jpg?alt=media&token=1f781293-ccd4-40f2-af09-7fa44149e25f',
      boards: [
        {
          name: 'basic',
          image:
            'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2FCaptura_001.png?alt=media&token=b9fa9f02-97d4-468c-96f5-ab7725bdd4af',
        },
        {
          name: 'advanced',
          image:
            'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2FCaptura_002.png?alt=media&token=463b059c-82df-4549-bb92-cc7934597512',
        },
        {
          name: 'pro',
          image:
            'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2FCaptura_003.png?alt=media&token=748cff28-e48f-4d33-8dd5-819a006bcef5',
        },
      ],
      statsImage:
        'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Femilio-garcia-768275-unsplash.jpg?alt=media&token=1efd1eb5-95de-4f96-ac22-694952eff932',
      stats: [
        {
          name: 'basic',
          image:
            'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Fstat_003.png?alt=media&token=f5b262ce-2fb2-4e95-b8d3-18bfabdfd78d',
        },
        {
          name: 'advanced',
          image:
            'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Fstat_001.png?alt=media&token=773330ae-cf74-4e4f-97dd-c266e0e2b8fe',
        },
        {
          name: 'pro',
          image:
            'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Fstat_002.png?alt=media&token=f458bfed-9b5c-4c5c-8f2e-9d46ef2a6fc8',
        },
      ],
      rolesImage:
        'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Fizuddin-helmi-adnan-427026-unsplash.jpg?alt=media&token=31535a7d-c419-459b-a6b3-735fdd263b5a',
      roles: ['administrator', 'editor', 'viewer', 'anonymous'],
      infoImage:
        'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/home%2Frick-rodriguez-427203-unsplash.jpg?alt=media&token=84bdf0c2-574b-4cb6-bc88-1e6b59e1ac1b',
    }
  },
  computed: {
    ...mapState({
      style: state => state.style.style,
    }),
  },
  watch: {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    navigateTo(to) {
      this.$router.push(to)
    },
    mailTo() {
      document.location.href = `mailto:${this.$t('site.email')}`
    },
    open(url) {
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss">
.cursor {
  cursor: pointer;
}
.cursor:hover {
  color: #64b5f6;
}
.board-image {
  max-width: 200px;
}
.stats-image {
  max-width: 300px;
}
.bg-home {
  // background-color: white;
}
.content-top {
  align-items: flex-start;
}

/* v-vpshow classes */
.before-enter {
  opacity: 0;
}
.enter {
  transition: opacity 2s ease;
}
/* ---------------- */
</style>
